import { Text } from "@/atoms"
import { ANALYTIC_EVENTS } from "@/const/event.constants"
import { FolderOpenOutlined } from "@/icons"
import { CommentsForm } from "@/pages/IntegrationsPage/components/molecules/CommentsForm"
import {
  ConfigItem,
  DescriptionLabelConfigItem,
  FooterConfigItem
} from "@/pages/IntegrationsPage/components/molecules/ConfigItem"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"

import type { BitbucketConfigurationItemProps } from "."

export const BitbucketConfigurationItem = (
  props: BitbucketConfigurationItemProps
) => {
  const [_, { isPending, onReset, isDirty, ...rest }] = useIntegration(props)
  const { keyPrefix, values } = props
  const { id, workspaceSlug, repoCount } = values
  const { t } = rest

  return (
    <ConfigItem
      key={id}
      values={values}
      Aside={
        workspaceSlug ? (
          <Text type="secondary">Workspace: {workspaceSlug}</Text>
        ) : null
      }
      Description={
        <DescriptionLabelConfigItem
          Icon={FolderOpenOutlined}
          tKey={`${keyPrefix}reposConnected`}
          count={Number(repoCount ?? 0)}
        />
      }
    >
      <CommentsForm
        label={t(`${keyPrefix}enableComments`)}
        mixPanelEvent={
          ANALYTIC_EVENTS.INTEGRATIONS.BITBUCKET.UPDATE_CONFIGURATION
        }
        {...values}
        {...rest}
      />
      <FooterConfigItem
        formId={id}
        isDirty={isDirty}
        isPending={isPending}
        permissions={{ action: "*", resource: "*" }}
        onReset={onReset}
      />
    </ConfigItem>
  )
}
